Vue.component('ack-elfsight-embed', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-elfsight-embed',
	created() {},
	mounted() {
		this.setElfsightWidget();
	},
	props: {
		pageId: 'elfsight-embed',
		widgetType: {
			type: String,
			required: true,
		},
	},
	computed: {
		isScriptExist() {
			return Array.from(document.getElementsByTagName('script')).some(
				(script) => script.src === this.elfsightScriptSrc,
			);
		},
	},
	// <ack-elfsight-embed :widget-type="'languageTranslator'"></ack-elfsight-embed>
	data() {
		return {
			currentClass: '',
			elfsightWidgetClasses: {
				languageTranslator: 'elfsight-app-145191b4-7d90-42e0-bdf7-7dd2fb1db889',
				// pages/application-workflow-xxx
				crownRoiCalculator: 'elfsight-app-6eced898-48c9-4ed9-b84d-52e6b4bba9ed',
				splintRoiCalculator: 'elfsight-app-4b3b0be4-aa28-42a9-8f3c-720d3c89cd21',
				allOnXRoiCalculator: 'elfsight-app-22567df6-b942-4bd2-a53d-a4bab56e6cae',
				dental3DPrinterSurvey: 'elfsight-app-083ce287-7378-4839-abcc-ca904d39c565',
				// pages/offices-and-team
				teamMembers: 'elfsight-app-1a4933f9-c096-4909-b9c3-5adb5f8b0c54',
				// pages/events
				events: 'elfsight-app-57e141b8-8574-4278-a043-74de10f1da12',
			},

			elfsightScriptSrc: 'https://static.elfsight.com/platform/platform.js',
		};
	},

	methods: {
		setElfsightWidget() {
			if (!this.widgetType) return;
			this.currentClass = this.elfsightWidgetClasses[this.widgetType];
			if (!this.isScriptExist) {
				const script = document.createElement('script');
				script.src = this.elfsightScriptSrc;
				script.async = true;
				document.body.appendChild(script);
			}
		},
	},
	beforeDestroy() {},
	watch: {
		isMobile: {
			handler() {},
			deep: false,
		},
	},
});
